/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-02-08 10:40:27
 * @LastEditors: 刘小博
 * @Description:
 * 系统设置
 */
import systemSettingRouter from './modules/systemSettingRouter'
const systemSettingsRouter = [].concat(systemSettingRouter)
export default systemSettingsRouter
